import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

export const Th = ({ children }) => <th className="p-3 font-medium">{children}</th>;
export const Td = ({ children, className = "" }) => <td className={`p-3 align-top ${className}`}>{children}</td>;

export function Table({ head, children, testid, empty }) {
  if (empty) return <p className="text-slate-500" data-testid={`${testid}-empty`}>Nessun elemento.</p>;
  return (
    <div className="overflow-x-auto rounded-2xl border border-white/10 bg-[#12141C]" data-testid={testid}>
      <table className="w-full text-left text-sm">
        <thead className="bg-white/5 text-xs uppercase tracking-wider text-slate-400"><tr>{head.map((h) => <Th key={h}>{h}</Th>)}</tr></thead>
        <tbody className="divide-y divide-white/5">{children}</tbody>
      </table>
    </div>
  );
}

export function Btn({ children, onClick, variant = "ghost", testid, disabled }) {
  const cls = {
    ghost: "border border-white/15 text-white hover:bg-white/10",
    ok: "bg-emerald-500 text-black hover:bg-emerald-400",
    warn: "border border-red-500/40 text-red-300 hover:bg-red-500/10",
    gold: "bg-amber-500 text-black hover:bg-amber-400",
  }[variant];
  return <button data-testid={testid} onClick={onClick} disabled={disabled} className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors disabled:opacity-50 ${cls}`}>{children}</button>;
}

export function NoteDialog({ title, onConfirm, onClose }) {
  const [note, setNote] = useState("");
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="border-white/10 bg-[#12141C]" data-testid="note-dialog">
        <DialogHeader><DialogTitle className="text-white">{title}</DialogTitle></DialogHeader>
        <Textarea data-testid="note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Motivo (visibile al partner)" className="bg-[#1C1F2C]" />
        <button data-testid="note-confirm" onClick={() => { onConfirm(note); onClose(); }} className="rounded-xl bg-amber-500 py-2 font-semibold text-black">Conferma</button>
      </DialogContent>
    </Dialog>
  );
}

export const downloadCsv = (name, rows) => {
  const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(";")).join("\n");
  const url = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }));
  Object.assign(document.createElement("a"), { href: url, download: name }).click();
  URL.revokeObjectURL(url);
};
